import { useNavigate } from "react-router-dom";
import { CustomList, CustomPageHeader } from "../../ui";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../contexts";
import CustomTag from "../../ui/CustomTag";
import axios from "axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../assets/constants";
import { PlusIcon, ShieldIcon, TrashIcon } from "@phosphor-icons/react";

const RoleList = () => {
    const { token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [selectedColumns, setSelectedColumns] = useState(0);
    const [selectedIds, setSelectedIds] = useState([]);
    const [refreshCounter, setRefreshCounter] = useState(0);

    const columns = React.useMemo(
        () => [
            {
                Header: "Nom",
                accessor: "name",
                icon: "user",
                Cell: ({ cell: { value } }) => <span>{value}</span>,
            },
            {
                Header: "Utilisateurs",
                accessor: "users",
                icon: "user",
                Cell: ({ cell: { value } }) => <CustomTag value={value ? value.length : 0} />,
            },
        ],
        []
    );

    const handleBulkDelete = () => {
        if (window.confirm("Attention : vous êtes sur le point de supprimer plusieurs rôles")) {
            axios
                .post(process.env.REACT_APP_UPA_API_HOST + "users/roles/bulk-delete", { selectedIds }, { headers: { Authorization: "Bearer " + token } })
                .then(() => {
                    toast.success("Rôles supprimés", toastOptions);
                    setRefreshCounter(refreshCounter + 1);
                })
                .catch((err) => {
                    toast.error(err.response.data.message, toastOptions);
                });
        }
    };
    return (
        <div className="c-app__view">
            <CustomPageHeader 
                title="Gestion des rôles"
                titleIcon={{ icon: ShieldIcon }}
                buttons={selectedColumns === 0 ? [
                    {
                        label: "Créer un rôle",
                        onClick: () => navigate("new"),
                        icon: PlusIcon,
                        variant: "primary"
                    }
                ] : [
                    {
                        label: "Supprimer",
                        onClick: handleBulkDelete,
                        icon: TrashIcon,
                        variant: "danger"
                    }
                ]}
            />
            <div className="tabs-container">
                <CustomList entity="users/roles" refreshData={refreshCounter} columns={columns} setSelectedColumns={setSelectedColumns} setSelectedIds={setSelectedIds} />
            </div>
        </div>
    );
};

export default RoleList;
